module.exports = __webpack_public_path__ + "img/gmail-new-icon.c459a7cc.png";